<template>
    <div>
        <v-tooltip v-if="!disableTooltip" bottom>
            <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" class="d-inline-block text-truncate" :style="styleObject">
                    {{ long_text }}
                </span>                                                        
            </template>
            <span v-html="convertTextToHtml(long_text)"></span>
        </v-tooltip>
        <span v-bind="attrs" v-on="on" class="d-inline-block text-truncate" :style="styleObject" v-if="disableTooltip">
            {{ long_text }}
        </span>                                                        
    </div>
</template>
<script>
    export default {
        props: {
            long_text: {
                type: String,
                required: true,
            },
            max_width: {
                type: Number,
                required: false,
                default: 150
            },
            disableTooltip: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        data() {
            return {        
            }
        },
        computed: {
            styleObject: function () {
                return {
                    "max-width": this.max_width + "px"
                }
            }
        },
        methods: {
            convertTextToHtml(text) {
                return text.replace(/\n/gi, '<br>'); // yes indeed, regular expression!!
            }
        }
    }
</script>

<style scoped> 
</style>